// Order matters: the storage prefix must be set before anything reads storage, and the i18n module
// must be imported before the first render (the LanguageProvider no longer initialises it).
import { configureAppCore } from '@invite/app-core';
configureAppCore({ storagePrefix: 'invite.owner' });

import './i18n/i18n';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { LanguageProvider } from '@invite/app-core';
import { App } from './App';
import './index.css';

const root = document.getElementById('root');
if (root === null) {
  throw new Error('Missing #root element');
}
createRoot(root).render(
  <StrictMode>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </StrictMode>
);
